import { render, staticRenderFns } from "./asides.vue?vue&type=template&id=0f70ab2e&scoped=true&"
import script from "./asides.vue?vue&type=script&lang=js&"
export * from "./asides.vue?vue&type=script&lang=js&"
import style0 from "./asides.vue?vue&type=style&index=0&id=0f70ab2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70ab2e",
  null
  
)

export default component.exports